/**
 * Theme plumbing, permanently locked to the Canvas Paper edition with black letters.
 * No day/night toggle or option exists.
 */
export const STORAGE_KEY = 'chapterco.theme';

export const THEMES = ['light'];

/** Browser UI colour (Android address bar, iOS status bar). */
export const THEME_COLORS = {
  light: '#E7E2DC',
};

/** Always resolves to light theme (pure black ink on warm paper). */
export function readStoredTheme() {
  return 'light';
}

export function storeTheme() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* nothing to do */
  }
}

export function systemTheme() {
  return 'light';
}

/** Always renders as light theme with pure black text. */
export function resolveTheme() {
  return 'light';
}

/**
 * Paint it. Sets data-theme="light", removes any dark class, and matches meta theme-color to the paper tone.
 */
export function applyTheme() {
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = 'light';
    document.documentElement.classList.remove('dark');
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', THEME_COLORS.light);
  }
}
